export class ForgotPasswordAttempt {
  email: string;

  constructor(email: string) {
    this.email = email;
  }
}
